/**
 * GameOver — match results, rematch, return to menu.
 *
 * Scale-relative layout matching MainMenu / About vertical rhythm with
 * black text strokes for legibility on pixel-art backgrounds.
 * Responsive: re-runs layout on every scale.resize event.
 */
import { Theme } from '../ui/Theme.js';
import { Button } from '../ui/Button.js';
import { SceneBackground } from '../ui/SceneBackground.js';
import { onResize, layoutSlot } from './ResponsiveScene.js';

export class GameOver extends Phaser.Scene {
  constructor() {
    super('GameOver');
  }

  init(data) {
    this.result = (data && data.result) || {};
  }

  create() {
    this.cameras.main.setBackgroundColor(Theme.colors.bg);
    const slot = layoutSlot();
    onResize(this, () => {
      slot.wipe();
      const bg = SceneBackground.fromRegistry(this);
      if (bg) slot.add(bg);
      this._layout(slot);
    });
  }

  _layout(slot) {
    const reg = this.registry;
    const manifest = reg.get('manifest');
    const i18n = reg.get('i18n');

    const W = this.scale.width;
    const H = this.scale.height;
    const cx = W / 2;

    // Title.
    slot.add(this.add.text(cx, H * 0.18, 'Game Over', {
      fontFamily: Theme.font.family,
      fontSize: Theme.font.sizes.xxl,
      color: Theme.colors.text,
      fontStyle: 'bold',
      stroke: '#000000',
      strokeThickness: 6
    }).setOrigin(0.5));

    // Winner + scores body.
    let body = '';
    if (this.result.winnerName) body += 'Winner: ' + this.result.winnerName + '\n';
    if (this.result.scores) {
      body += '\nScores\n';
      for (const [id, score] of Object.entries(this.result.scores)) {
        body += '• ' + id + ': ' + score + '\n';
      }
    }
    if (body) {
      slot.add(this.add.text(cx, H * 0.45, body, {
        fontFamily: Theme.font.family,
        fontSize: Theme.font.sizes.md,
        color: Theme.colors.text,
        align: 'center',
        stroke: '#000000',
        strokeThickness: 3,
        lineSpacing: 4
      }).setOrigin(0.5));
    }

    // Back to menu (bottom-center).
    const backBtn = new Button({
      scene: this,
      x: cx, y: H * 0.85,
      label: i18n ? i18n.t('common.back', 'Back to menu') : 'Back to menu',
      onClick: () => this.scene.start('MainMenu')
    });
    slot.add(backBtn.container);

    // Version footer (bottom-right corner).
    slot.add(this.add.text(W - 12, H - 12, 'v' + manifest.version, {
      fontFamily: Theme.font.family,
      fontSize: Theme.font.sizes.sm,
      color: Theme.colors.text,
      stroke: '#000000',
      strokeThickness: 3
    }).setOrigin(1, 1));
  }
}
